// hooks/useAllMessages.js
import { useEffect, useState } from "react";

import { fetchMessages } from "../../api/api";

export const useAllMessages = (topics) => {
  const [allMessages, setAllMessages] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!topics || topics.length === 0) return;

    setLoading(true);
    Promise.all(
      topics.map((topic) =>
        fetchMessages(topic.id).then((messages) =>
          messages.map((msg) => ({
            ...msg,
            topicId: topic.id,
            topic: topic.name,
          }))
        )
      )
    )
      .then((results) => {
        setAllMessages(results.flat());
        setLoading(false);
      })
      .catch((err) => {
        setError(err);
        setLoading(false);
      });
  }, [topics]);

  return { allMessages, loading, error };
};
